import React from "react";
import {
  WSCard,
  WSElement,
  WSButton,
  WSFlexBox,
  WSText,
  WSIcon,
  WSAlert
} from "@wingspanhq/fe-component-library";
import { ClientInfo } from "./ClientInfo";
import { ScopesList } from "./ScopesList";
import { IOAuthAuthorizeResponse } from "../types";
import styles from "./AuthorizeConsent.module.scss";

interface AuthorizeConsentProps {
  authorizeData: IOAuthAuthorizeResponse;
  onApprove: () => void;
  onDeny: () => void;
  isLoading: boolean;
}

export const AuthorizeConsent: React.FC<AuthorizeConsentProps> = ({
  authorizeData,
  onApprove,
  onDeny,
  isLoading
}) => {
  const { client, scopes } = authorizeData;

  return (
    <WSCard className={styles.card}>
      <ClientInfo client={client} />

      <WSElement mb="L">
        <ScopesList scopes={scopes} />
      </WSElement>

      <WSAlert theme="info" icon="info-circle" mb="L">
        <WSFlexBox direction="column" gap="XS">
          <WSText.Paragraph weight="medium">
            Session-only authorization
          </WSText.Paragraph>
          <WSText.ParagraphSm>
            This authorization is valid only for your current session. You'll be
            asked to approve again after logging out.
          </WSText.ParagraphSm>
        </WSFlexBox>
      </WSAlert>

      <WSFlexBox gap="M">
        <WSButton.Secondary onClick={onDeny} disabled={isLoading} fullWidth>
          Deny
        </WSButton.Secondary>
        <WSButton.Primary
          onClick={onApprove}
          disabled={isLoading}
          loading={isLoading}
          fullWidth
        >
          Approve
        </WSButton.Primary>
      </WSFlexBox>

      {(client.tosUri || client.policyUri) && (
        <WSElement mt="L" pt="L" className={styles.footerSection}>
          <WSFlexBox.Center gap="M">
            {client.tosUri && (
              <a
                href={client.tosUri}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.footerLink}
              >
                Terms of Service
              </a>
            )}
            {client.tosUri && client.policyUri && (
              <WSText.ParagraphSm color="gray400">•</WSText.ParagraphSm>
            )}
            {client.policyUri && (
              <a
                href={client.policyUri}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.footerLink}
              >
                Privacy Policy
              </a>
            )}
          </WSFlexBox.Center>
        </WSElement>
      )}
    </WSCard>
  );
};
